import { KeyBindingUtil, RichUtils } from 'draft-js';
import { List } from 'immutable';
import { BlockType } from '@uno/common-cms';
import { addNewBlock, continuousBlocks, getCurrentBlock, isHighlightedBlock, resetBlockType } from './block';

var isEndOfNotContinuousBlock = function isEndOfNotContinuousBlock(editorState) {
  var selection = editorState.getSelection();
  var currentBlock = getCurrentBlock(editorState);

  if (selection.isCollapsed() && currentBlock.getLength() === selection.getStartOffset() && !continuousBlocks.includes(currentBlock.getType())) {
    return true;
  }

  return false;
};

var isIndexZeroOnHighlightedBlock = function isIndexZeroOnHighlightedBlock(editorState) {
  var selection = editorState.getSelection();
  var currentBlock = getCurrentBlock(editorState);
  return isHighlightedBlock(currentBlock) && 0 === selection.getStartOffset() && currentBlock.getText().length > 0;
};

var isLastHighlightedListItem = function isLastHighlightedListItem(editorState) {
  var selection = editorState.getSelection();
  var currentBlock = getCurrentBlock(editorState);
  return isHighlightedBlock(currentBlock) && [BlockType.UL, BlockType.OL].includes(currentBlock.getType()) && currentBlock.getLength() === selection.getStartOffset();
};

var isBetweenHighlightedBlocks = function isBetweenHighlightedBlocks(editorState) {
  var selection = editorState.getSelection();
  var currentBlock = getCurrentBlock(editorState);
  var nextBlock = editorState.getCurrentContent().getBlockAfter(currentBlock.getKey());
  return isHighlightedBlock(currentBlock) && isHighlightedBlock(nextBlock) && currentBlock.getLength() === selection.getStartOffset();
}; // eslint-disable-next-line complexity


export var updateEditorStateOnReturn = function updateEditorStateOnReturn(editorState, event) {
  var currentBlock = getCurrentBlock(editorState);
  var blockType = currentBlock.getType();

  switch (true) {
    // soft return : "Shift + enter"
    case KeyBindingUtil.isSoftNewlineEvent(event):
      return RichUtils.insertSoftNewline(editorState);
    // current block is atomic

    case blockType === BlockType.ATOMIC:
      return addNewBlock('after', editorState, currentBlock);
    // current block is empty and not unstyled

    case currentBlock.getLength() === 0 && blockType !== BlockType.UNSTYLED:
      return resetBlockType(editorState);
    // cursor is at the end of an not continuous block

    case isEndOfNotContinuousBlock(editorState):
      return addNewBlock('after', editorState, currentBlock);
    // keep highlight value on "Enter" :
    // - between highlighted
    // - after the last highlighted list item

    case isBetweenHighlightedBlocks(editorState):
    case isLastHighlightedListItem(editorState):
      return addNewBlock('after', editorState, currentBlock, {
        initialData: {
          highlighted: true
        },
        characterList: List(),
        blockType: currentBlock.getType(),
        depth: currentBlock.getDepth()
      });
    // handle "Enter" on index 0 of a highlighted block

    case isIndexZeroOnHighlightedBlock(editorState):
      return addNewBlock('before', editorState, currentBlock, {
        initialData: {
          highlighted: true
        },
        characterList: List(),
        blockType: currentBlock.getType(),
        depth: currentBlock.getDepth()
      });

    default:
      break;
  }

  return null;
};